import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/PartnerGroups/helpers'
import partnerGroupsRepository from '@/repository/generatedRepository/partnerGroupsRepository'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.PARTNER_GROUPS_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, payload) {
    const {signal, ...filters} = payload
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.PARTNER_GROUPS_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
      signal,
      isFilter: 1,
    })

    const { data } = await partnerGroupsRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async searchPartnerGroups(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })

    const { data } = await partnerGroupsRepository.list(preparedFilters)

    return { options: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await partnerGroupsRepository.get(id)
    return data
  },
  createItem(context, payload) {
    return partnerGroupsRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return partnerGroupsRepository.put(id, data)
  },
  createPartnerGroupManager(context, payload) {
    return partnerGroupsRepository.createPartnerGroupManager(payload)
  },
  updatePartnerGroupManager(context, payload) {
    const { id, ...data } = payload
    return partnerGroupsRepository.updatePartnerGroupManager(id, data)
  },
  deletePartnerGroupManager(context, payload) {
    return partnerGroupsRepository.deletePartnerGroupManager(payload)
  },
  deleteItem(context, payload) {
    return partnerGroupsRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.PARTNER_GROUPS_FILTERS)
  },
  resetSearchFilter({commit}){
    commit('clearSearch')
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.PARTNER_GROUPS_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
  clearSearch(state) {
    state.tableOptions.search = ''
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
